"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OptionalFlex = undefined;

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var OptionalFlex = exports.OptionalFlex = _styledComponents2.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: ", ";\n  align-items: ", ";\n  width: 100%;\n  text-align: ", ";\n  flex-direction: ", "\n  height: ", "\n\n  justify-content: ", ";\n\n  ", ";\n"], ["\n  display: ", ";\n  align-items: ", ";\n  width: 100%;\n  text-align: ", ";\n  flex-direction: ", "\n  height: ", "\n\n  justify-content: ", ";\n\n  ", ";\n"])), function (_a) {
    var flex = _a.flex;
    return flex && 'flex' || 'block';
}, function (_a) {
    var alignVertically = _a.alignVertically;
    return alignVertically || 'center';
}, function (_a) {
    var flex = _a.flex;
    return flex && 'left' || 'center';
}, function (_a) {
    var direction = _a.direction;
    return direction || 'row';
}, function (_a) {
    var height = _a.height;
    return height || 'unset';
}, function (_a) {
    var alignHorizontally = _a.alignHorizontally;
    return alignHorizontally || 'flex-start';
}, function (_a) {
    var responsive = _a.responsive;
    return responsive && (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (max-width: 70rem) {\n        display: block;\n      }\n    "], ["\n      @media (max-width: 70rem) {\n        display: block;\n      }\n    "])));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=layout.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/styles/layout.js
// module id = 403
// module chunks = 0